import React from 'react'

import Script from 'dangerous-html/react'
import { Helmet } from 'react-helmet'

import Navigation from '../components/navigation'
import Footer from '../components/footer'
import './home.css'

const Home = (props) => {
  return (
    <div className="home-container1">
      <Helmet>
        <title>Dogeet</title>
        <meta property="og:title" content="Dogeet" />
        <link
          rel="canonical"
          href="https://dogeet.com/"
        />
      </Helmet>
      <Navigation></Navigation>
      <div className="home-container2">
        <div className="home-container3">
          <Script
            html={`<style>
input:checked + .hero-slider {
  background-color: var(--color-primary);
}
input:checked + .hero-slider:before {
  transform: translateX(20px);
}
</style>`}
          ></Script>
        </div>
      </div>
      <section className="hero-section">
        <div className="hero-media-container">
          <img
            src="https://images.pexels.com/photos/16680583/pexels-photo-16680583.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
            alt="Playful Shiba Inu in a golden field"
            className="hero-bg-image"
          />
          <div className="hero-overlay"></div>
        </div>
        <div className="hero-content-wrapper">
          <div className="hero-content-card">
            <div className="hero-badge">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewbox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M6 12h6M9 6v12m-3 0h6a6 6 0 1 0 0-12H6"></path>
              </svg>
              <span>1 DOGE = 1 DOGE</span>
            </div>
            <h1 className="home-hero-title hero-title">
              Much Bazaar. Very Local. Such DOGE.
            </h1>
            <p className="home-hero-subtitle hero-subtitle">
              The world&apos;s first Dogecoin-only classifieds. Trade your wares
              for the coin of the people. No middleman, just community.
            </p>
            <div className="hero-action-group">
              <div className="hero-location-input">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewbox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0"></path>
                  <circle cx="12" cy="10" r="3"></circle>
                </svg>
                <input
                  type="text"
                  placeholder="Enter City or Zip..."
                  aria-label="Location search"
                />
              </div>
              <div className="hero-btn-row">
                <a href="#">
                  <div className="btn btn-primary btn-lg">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewbox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M14.106 5.553a2 2 0 0 0 1.788 0l3.659-1.83A1 1 0 0 1 21 4.619v12.764a1 1 0 0 1-.553.894l-4.553 2.277a2 2 0 0 1-1.788 0l-4.212-2.106a2 2 0 0 0-1.788 0l-3.659 1.83A1 1 0 0 1 3 19.381V6.618a1 1 0 0 1 .553-.894l4.553-2.277a2 2 0 0 1 1.788 0l4.212 2.106a2 2 0 0 0 1.788 0l3.659-1.83A1 1 0 0 1 21 4.619V12m-6-6.236V12m3 3v6m3-3h-6M9 3.236v15"></path>
                    </svg>
                    <span>Browse Map</span>
                  </div>
                </a>
                <a href="#">
                  <div className="btn btn-lg btn-secondary">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewbox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M5 12h14m-7-7v14"></path>
                    </svg>
                    <span>Post Listing</span>
                  </div>
                </a>
              </div>
            </div>
            <div className="hero-toggle-container">
              <span className="hero-toggle-label">Show USD Reference</span>
              <label className="hero-switch">
                <input type="checkbox" id="usdToggle" />
                <span className="home-thq-hero-slider-elm"></span>
              </label>
            </div>
          </div>
        </div>
      </section>
      <section className="explore-section">
        <div className="explore-container">
          <div className="explore-card">
            <div className="explore-header">
              <h2 className="section-title">Find Wares Near You</h2>
              <p className="section-content">
                Discover what your neighbors are trading for DOGE.
              </p>
            </div>
            <form
              data-form-id="39020210-7419-4d19-8e04-c56f9743cadf"
              className="explore-form"
            >
              <div className="explore-input-group">
                <div className="explore-field">
                  <label className="explore-label">Location</label>
                  <div className="explore-input-wrapper">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      viewbox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                    >
                      <circle cx="11" cy="11" r="8"></circle>
                      <path d="m21 21l-4.34-4.34"></path>
                    </svg>
                    <input
                      type="text"
                      placeholder="City or Zip Code"
                      required="true"
                      id="thq_textinput_cGRQ"
                      name="textinput"
                      data-form-field-id="thq_textinput_cGRQ"
                    />
                  </div>
                </div>
                <div className="explore-field explore-field-radius">
                  <label className="explore-label">Radius</label>
                  <select
                    id="thq_select_xAiF"
                    name="select"
                    data-form-field-id="thq_select_xAiF"
                    className="explore-select"
                  >
                    <option>5 miles</option>
                    <option selected="true">10 miles</option>
                    <option>25 miles</option>
                    <option>50 miles</option>
                    <option>Worldwide</option>
                  </select>
                </div>
                <button
                  type="submit"
                  id="thq_button_NA58"
                  name="button"
                  data-form-field-id="thq_button_NA58"
                  className="explore-submit btn btn-primary"
                >
                  <span>Explore Map</span>
                </button>
              </div>
            </form>
            <div className="explore-shortcuts">
              <span className="explore-shortcuts-title">Quick Categories:</span>
              <div className="explore-chips">
                <a href="#">
                  <div className="explore-chip">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      viewbox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                    >
                      <path d="M16 10a4 4 0 0 1-8 0M3.103 6.034h17.794"></path>
                      <path d="M3.4 5.467a2 2 0 0 0-.4 1.2V20a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6.667a2 2 0 0 0-.4-1.2l-2-2.667A2 2 0 0 0 17 2H7a2 2 0 0 0-1.6.8z"></path>
                    </svg>
                    <span>Electronics</span>
                  </div>
                </a>
                <a href="#">
                  <div className="explore-chip">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      viewbox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                    >
                      <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2M16 3.128a4 4 0 0 1 0 7.744M22 21v-2a4 4 0 0 0-3-3.87"></path>
                      <circle cx="9" cy="7" r="4"></circle>
                    </svg>
                    <span>Collectibles</span>
                  </div>
                </a>
                <a href="#">
                  <div className="explore-chip">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      viewbox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                    >
                      <path d="M3.85 8.62a4 4 0 0 1 4.78-4.77a4 4 0 0 1 6.74 0a4 4 0 0 1 4.78 4.78a4 4 0 0 1 0 6.74a4 4 0 0 1-4.77 4.78a4 4 0 0 1-6.75 0a4 4 0 0 1-4.78-4.77a4 4 0 0 1 0-6.76M12 8v8m-4-4h8"></path>
                    </svg>
                    <span>Services</span>
                  </div>
                </a>
                <a href="#">
                  <div className="explore-chip">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      viewbox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                    >
                      <path d="M5 12h14m-7-7v14"></path>
                    </svg>
                    <span>More</span>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="steps-section">
        <div className="steps-container">
          <div className="steps-intro">
            <h2 className="section-title">How Dogeet Works</h2>
            <p className="section-content">
              Simple, decentralized, and community-driven. Khajiit has wares if
              you have coin.
            </p>
          </div>
          <div className="steps-grid">
            <div className="step-item">
              <div className="step-icon-box">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="32"
                  height="32"
                  viewbox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                >
                  <path d="M5 12h14m-7-7v14"></path>
                </svg>
                <div className="step-number">
                  <span>1</span>
                </div>
              </div>
              <h3 className="section-subtitle">Post Your Wares</h3>
              <p className="section-content">
                List anything you want to sell. Set your price in DOGE.
                It&apos;s fast, free, and easy.
              </p>
            </div>
            <div className="step-item">
              <div className="step-icon-box">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="32"
                  height="32"
                  viewbox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                >
                  <path d="M14.106 5.553a2 2 0 0 0 1.788 0l3.659-1.83A1 1 0 0 1 21 4.619v12.764a1 1 0 0 1-.553.894l-4.553 2.277a2 2 0 0 1-1.788 0l-4.212-2.106a2 2 0 0 0-1.788 0l-3.659 1.83A1 1 0 0 1 3 19.381V6.618a1 1 0 0 1 .553-.894l4.553-2.277a2 2 0 0 1 1.788 0l4.212 2.106a2 2 0 0 0 1.788 0l3.659-1.83A1 1 0 0 1 21 4.619V12m-6-6.236V12m3 3v6m3-3h-6M9 3.236v15"></path>
                </svg>
                <div className="step-number">
                  <span>2</span>
                </div>
              </div>
              <h3 className="section-subtitle">Discover Locally</h3>
              <p className="section-content">
                Use our map to find treasures in your neighborhood. See prices
                in real-time DOGE.
              </p>
            </div>
            <div className="step-item">
              <div className="step-icon-box">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="32"
                  height="32"
                  viewbox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                >
                  <path d="m16 3l4 4l-4 4m4-4H4m4 14l-4-4l4-4m-4 4h16"></path>
                </svg>
                <div className="step-number">
                  <span>3</span>
                </div>
              </div>
              <h3 className="section-subtitle">Trade Peer-to-Peer</h3>
              <p className="section-content">
                Connect directly with buyers. Non-custodial, private, and
                secure. Just pure trade.
              </p>
            </div>
          </div>
        </div>
      </section>
      <section className="featured-section">
        <div className="featured-header">
          <div className="container-inner">
            <h2 className="section-title">Featured Listings</h2>
            <p className="section-content">
              Hand-picked treasures currently available for DOGE.
            </p>
          </div>
        </div>
        <div className="featured-carousel-wrapper">
          <div className="featured-carousel">
            <div className="listing-card">
              <div className="listing-image">
                <img
                  src="https://images.pexels.com/photos/19146933/pexels-photo-19146933.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                  alt="Vintage Camera"
                />
                <div className="listing-badge">
                  <span>Featured</span>
                </div>
              </div>
              <div className="listing-info">
                <h3 className="listing-title">Vintage Film Camera</h3>
                <p className="listing-location">Brooklyn, NY</p>
                <div className="listing-price">
                  <span className="doge-price">4,200 DOGE</span>
                  <span className="usd-ref">≈ $630.00 USD</span>
                </div>
                <a href="#">
                  <div className="listing-btn btn btn-outline btn-sm">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      viewbox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                    >
                      <path d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0"></path>
                      <circle cx="12" cy="10" r="3"></circle>
                    </svg>
                    <span>View on Map</span>
                  </div>
                </a>
              </div>
            </div>
            <div className="listing-card">
              <div className="listing-image">
                <img
                  src="https://images.pexels.com/photos/13062512/pexels-photo-13062512.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                  alt="Handmade Vase"
                />
              </div>
              <div className="listing-info">
                <h3 className="listing-title">Artisanal Ceramic Vase</h3>
                <p className="listing-location">Austin, TX</p>
                <div className="listing-price">
                  <span className="doge-price">850 DOGE</span>
                  <span className="usd-ref">≈ $127.50 USD</span>
                </div>
                <a href="#">
                  <div className="listing-btn btn btn-outline btn-sm">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      viewbox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                    >
                      <path d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0"></path>
                      <circle cx="12" cy="10" r="3"></circle>
                    </svg>
                    <span>View on Map</span>
                  </div>
                </a>
              </div>
            </div>
            <div className="listing-card">
              <div className="listing-image">
                <img
                  src="https://images.pexels.com/photos/2187304/pexels-photo-2187304.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                  alt="Custom Skateboard"
                />
                <div className="listing-badge">
                  <span>New</span>
                </div>
              </div>
              <div className="listing-info">
                <h3 className="listing-title">Custom Shiba Skateboard</h3>
                <p className="listing-location">Los Angeles, CA</p>
                <div className="listing-price">
                  <span className="doge-price">1,500 DOGE</span>
                  <span className="usd-ref">≈ $225.00 USD</span>
                </div>
                <a href="#">
                  <div className="listing-btn btn btn-outline btn-sm">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      viewbox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                    >
                      <path d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0"></path>
                      <circle cx="12" cy="10" r="3"></circle>
                    </svg>
                    <span>View on Map</span>
                  </div>
                </a>
              </div>
            </div>
            <div className="listing-card">
              <div className="listing-image">
                <img
                  src="https://images.pexels.com/photos/4422098/pexels-photo-4422098.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                  alt="Gamer Chair"
                />
              </div>
              <div className="listing-info">
                <h3 className="listing-title">Pro Gaming Chair</h3>
                <p className="listing-location">London, UK</p>
                <div className="listing-price">
                  <span className="doge-price">2,800 DOGE</span>
                  <span className="usd-ref">≈ $420.00 USD</span>
                </div>
                <a href="#">
                  <div className="listing-btn btn btn-outline btn-sm">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      viewbox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                    >
                      <path d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0"></path>
                      <circle cx="12" cy="10" r="3"></circle>
                    </svg>
                    <span>View on Map</span>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="community-section">
        <div className="community-container">
          <div className="community-intro">
            <h2 className="section-title">Community Vibes</h2>
            <p className="section-content">
              Real shibes, real trades. Join the most friendly bazaar in the
              galaxy.
            </p>
          </div>
          <div className="community-stats">
            <div className="stat-card">
              <span className="stat-value">12.5k</span>
              <span className="stat-label">Active Shibes</span>
            </div>
            <div className="stat-card">
              <span className="stat-value">840k</span>
              <span className="stat-label">DOGE Traded</span>
            </div>
            <div className="stat-card">
              <span className="stat-value">4.9/5</span>
              <span className="stat-label">Trust Score</span>
            </div>
          </div>
          <div className="testimonial-carousel">
            <div className="testimonial-card">
              <div className="testimonial-content">
                <p>
                  &quot;Sold my old GPU for 5000 DOGE. The buyer brought snacks.
                  Best marketplace experience ever. Much wow!&quot;
                </p>
              </div>
              <div className="testimonial-author">
                <img
                  src="https://images.pexels.com/photos/4588013/pexels-photo-4588013.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                  alt="User Profile"
                />
                <div className="author-info">
                  <span className="author-name">DogeLover99</span>
                  <span className="author-meta">Verified Seller</span>
                </div>
              </div>
            </div>
            <div className="testimonial-card">
              <div className="testimonial-content">
                <p>
                  &quot;Found a local artist selling custom prints for DOGE. The
                  map view made it so easy to meet up safely. 10/10!&quot;
                </p>
              </div>
              <div className="testimonial-author">
                <img
                  src="https://images.pexels.com/photos/4588015/pexels-photo-4588015.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                  alt="User Profile"
                />
                <div className="author-info">
                  <span className="author-name">MoonWalker</span>
                  <span className="author-meta">Local Buyer</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="cta-banner">
        <div className="cta-banner-container">
          <div className="cta-alert-box">
            <div className="cta-alert-icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="32"
                height="32"
                viewbox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
              >
                <path d="M10.268 21a2 2 0 0 0 3.464 0M15 8h6m-3-3v6m2.002 3.464a9 9 0 0 0 .738.863A1 1 0 0 1 20 17H4a1 1 0 0 1-.74-1.673C4.59 13.956 6 12.499 6 8a6 6 0 0 1 8.75-5.332"></path>
              </svg>
            </div>
            <div className="cta-alert-content">
              <h2 className="section-title">Ready to sell for DOGE?</h2>
              <p className="section-content">
                Post your first listing in under 60 seconds. All items are
                moderated for safety. To the moon!
              </p>
            </div>
            <div className="cta-alert-actions">
              <a href="#">
                <div className="btn btn-lg btn-accent">
                  <span>Post a Listing Now</span>
                </div>
              </a>
              <a href="#">
                <div className="btn btn-link">
                  <span>Safety Rules</span>
                </div>
              </a>
            </div>
          </div>
        </div>
      </section>
      <section className="about-section">
        <div className="about-container">
          <div className="about-card">
            <div className="about-grid">
              <div className="about-text">
                <h2 className="section-title">Why Dogeet?</h2>
                <p className="section-content">
                  Dogeet was born from a simple idea: Dogecoin is the
                  people&apos;s currency, and the people need a place to trade.
                  We&apos;re a non-custodial, peer-to-peer marketplace focused
                  on local discovery and community trust.
                </p>
                <p className="section-content">
                  No hidden fees, no complicated wallets, just friendly
                  neighbors trading wares for the coin that conquered the
                  internet.
                </p>
                <div className="about-links">
                  <a href="#">
                    <div className="btn btn-outline">
                      <span>Our Mission</span>
                    </div>
                  </a>
                  <a href="#">
                    <div className="btn btn-outline">
                      <span>Community Rules</span>
                    </div>
                  </a>
                </div>
              </div>
              <div className="about-visual">
                <img
                  src="https://images.pexels.com/photos/14164734/pexels-photo-14164734.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                  alt="Shiba Inu"
                  className="about-img"
                />
                <div className="about-floating-badge">
                  <span>Since 2024</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <div className="home-container4">
        <div className="home-container5">
          <Script
            html={`<style>
        @keyframes slideUp {from {opacity: 0;
transform: translateY(30px);}
to {opacity: 1;
transform: translateY(0);}}
        </style> `}
          ></Script>
        </div>
      </div>
      <div className="home-container6">
        <div className="home-container7">
          <Script
            html={`<script defer data-name="dogeet-logic">
(function(){
  // Handle USD Toggle logic
  const usdToggle = document.getElementById('usdToggle');
  const usdRefs = document.querySelectorAll('.usd-ref');

  usdToggle.addEventListener('change', (e) => {
    usdRefs.forEach(ref => {
      ref.style.display = e.target.checked ? 'block' : 'none';
    });
  });

  // Initialize USD refs based on default toggle state
  usdRefs.forEach(ref => {
    ref.style.display = usdToggle.checked ? 'block' : 'none';
  });

  // Smooth scroll for explore chips (simulated behavior)
  const chips = document.querySelectorAll('.explore-chip');
  chips.forEach(chip => {
    chip.addEventListener('click', (e) => {
      e.preventDefault();
      // In a real app, this would filter the map/category
      console.log('Filtering by:', chip.textContent.trim());
    });
  });

  // Scroll Reveal Animation Observer (Subtle)
  const observerOptions = {
    threshold: 0.1
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.style.opacity = "1";
        entry.target.style.transform = "translateY(0)";
      }
    });
  }, observerOptions);

  // Apply to sections for staggered reveal effect
  const animElements = document.querySelectorAll('.step-item, .listing-card, .stat-card, .testimonial-card');
  animElements.forEach(el => {
    el.style.opacity = "0";
    el.style.transform = "translateY(20px)";
    el.style.transition = "all 0.6s ease-out";
    observer.observe(el);
  });
})()
</script>`}
          ></Script>
        </div>
      </div>
      <Footer></Footer>
    </div>
  )
}

export default Home
